module.exports = __webpack_public_path__ + "media/assets/img/logo-e78777cbd43e4e85e806d3058ff8de29.svg";